import { supabase } from '../lib/supabase';

export const phaseService = {
  async getPhasesByProject(projectId) {
    const { data, error } = await supabase?.from('project_phases')?.select('*')?.eq('project_id', projectId)?.order('phase_order', { ascending: true });
    
    if (error) throw error;
    
    return data?.map(phase => ({
      id: phase?.id,
      projectId: phase?.project_id,
      name: phase?.name,
      description: phase?.description,
      phaseOrder: phase?.phase_order,
      startDate: phase?.start_date,
      estimatedEndDate: phase?.estimated_end_date,
      actualEndDate: phase?.actual_end_date,
      status: phase?.status,
      progressPercentage: phase?.progress_percentage,
      createdAt: phase?.created_at,
      updatedAt: phase?.updated_at
    }));
  },

  async createPhase(phaseData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Não autenticado');

    const { data, error } = await supabase?.from('project_phases')?.insert({
        project_id: phaseData?.projectId,
        name: phaseData?.name,
        description: phaseData?.description,
        phase_order: phaseData?.phaseOrder,
        start_date: phaseData?.startDate,
        estimated_end_date: phaseData?.estimatedEndDate
      })?.select()?.single();
    
    if (error) throw error;
    
    return {
      id: data?.id,
      projectId: data?.project_id,
      name: data?.name,
      description: data?.description,
      phaseOrder: data?.phase_order,
      startDate: data?.start_date,
      estimatedEndDate: data?.estimated_end_date,
      status: data?.status,
      progressPercentage: data?.progress_percentage
    };
  },

  async updatePhase(phaseId, updates) {
    const dbUpdates = {};
    if (updates?.name !== undefined) dbUpdates.name = updates?.name;
    if (updates?.description !== undefined) dbUpdates.description = updates?.description;
    if (updates?.phaseOrder !== undefined) dbUpdates.phase_order = updates?.phaseOrder;
    if (updates?.startDate !== undefined) dbUpdates.start_date = updates?.startDate;
    if (updates?.estimatedEndDate !== undefined) dbUpdates.estimated_end_date = updates?.estimatedEndDate;
    if (updates?.actualEndDate !== undefined) dbUpdates.actual_end_date = updates?.actualEndDate;

    const { data, error } = await supabase?.from('project_phases')?.update(dbUpdates)?.eq('id', phaseId)?.select()?.single();
    
    if (error) throw error;
    return data;
  },

  async deletePhase(phaseId) {
    const { error } = await supabase?.from('project_phases')?.delete()?.eq('id', phaseId);
    
    if (error) throw error;
  },

  async completePhase(phaseId) {
    const { data, error } = await supabase?.from('project_phases')?.update({
        actual_end_date: new Date()?.toISOString(),
        progress_percentage: 100
      })?.eq('id', phaseId)?.select()?.single();
    
    if (error) throw error;
    return data;
  }
};